<template>
    <div class="guide">
        <div class="guide-img">
            <img
                v-for="(image, index) in imgs"
                :src="image"
                alt="引导图片"
                :key="'image__-' + index"
            >
        </div>
    </div>
</template>

<script>
export default {
    // 小程序引导页
    name: 'GuidePage',
    data() {
        return {
            imgs: [
                'http://image.jxt1314.com/mini/member/h5_01.png ',
                'http://image.jxt1314.com/mini/member/h5_02.png ',
                'http://image.jxt1314.com/mini/member/h5_03.png ',
                "http://image.jxt1314.com/mini/member/h5_04.png "
            ] 
        }
    },
}
</script>

<style lang="scss" scoped>
    .guide {
        position: relative;
        text-align: center;
        &-img {
            max-width: 375px;
            margin: auto;
            img {
                width: 375px;
                display: flex;
            }
        }
    }
</style>